"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var uniqid_1 = __importDefault(require("uniqid"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Drawer_1 = require("../../atoms/_Drawer/Drawer");

var Icon_1 = require("../../atoms/Icon");

var SideNavigationItems_1 = require("../_SideNavigationItems/SideNavigationItems");

var IconLink_1 = require("../IconLink");

var InputSearch_1 = require("../InputSearch");

var Logo_1 = require("../Logo");
/** Stateful Component, when viewport is XL or LG, SideNavigation is fix at the left side of page; when MS, MD or XS, it is a Drawer */


var SideNavigation =
/** @class */
function (_super) {
  __extends(SideNavigation, _super);

  function SideNavigation(props) {
    var _this = _super.call(this, props) || this;

    _this.toggleSideNavigation = function () {
      _this.setState({
        drawerOpen: !_this.state.drawerOpen
      });
    };

    _this.onSearchInputChange = function (value, name, event) {
      return _this.props.onSearchInputChange && _this.props.onSearchInputChange(value, name, event);
    };

    _this.registerSticky = function () {
      if (["xs", "sm", "md"].includes(_this.state.viewport)) {
        if (!utils_1.WindowEvents.getStickyElements().map(function (item) {
          return item.name;
        }).includes(_this.uuid)) {
          utils_1.WindowEvents.addStickyElement(_this.uuid, _this.containerElm);
        }
      } else utils_1.WindowEvents.removeStickyElement(_this.uuid);
    };

    _this.onResize = function (viewportSize) {
      _this.setState({
        viewport: viewportSize
      });
    };

    _this.uuid = _this.props.id || uniqid_1["default"]("lsg--sidenavigation");
    _this.state = {
      drawerOpen: false,
      viewport: utils_1.WindowEvents.getViewportSize(),
      activeItem: props.defaultActiveTargetValue
    };
    return _this;
  }

  SideNavigation.prototype.componentDidMount = function () {
    utils_1.WindowEvents.addViewportCallback(this.onResize);
    this.registerSticky();
  };

  SideNavigation.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.removeViewportCallback(this.onResize);
  };

  SideNavigation.prototype.componentDidUpdate = function () {
    this.registerSticky();
  };

  SideNavigation.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        searchDisabled = _a.searchDisabled,
        searchPlaceholder = _a.searchPlaceholder,
        navigationObject = _a.navigationObject,
        indicatorAtLevel = _a.indicatorAtLevel,
        topLogoHref = _a.topLogoHref,
        topLogoLabel = _a.topLogoLabel;
    var sideNaviClassnames = utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "sidenavigation", className]);
    var containerProps = {
      className: sideNaviClassnames,
      id: this.uuid
    };
    var richNavigationObject = utils_1.NavigationUtils.deepGenerateNavObject(navigationObject, this.uuid); // first generate a new navigationObject in which every item has an id

    var flatNavObj = utils_1.NavigationUtils.deepFlatten(richNavigationObject); // TODO: there should be another way, where we do not need to flatten

    var sideNavigationContent = React.createElement(React.Fragment, null, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "sidenavigation-search"
    }, React.createElement(InputSearch_1.InputSearch, {
      placeholder: searchPlaceholder,
      disabled: searchDisabled,
      onChange: this.props.onSearchInputChange
    })), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "sidenavigation-indicatorlinks"
    }, richNavigationObject && React.createElement(SideNavigationItems_1.SideNavigationItems, {
      items: richNavigationObject,
      activeItem: this.state.activeItem,
      indicatorAtLevel: indicatorAtLevel,
      onChange: function onChange(targetValue, ev) {
        if (flatNavObj // !children is not enough as an empty array [] will be evaluated to true
        // see: https://stackoverflow.com/questions/5491605/empty-arrays-seem-to-equal-true-and-false-at-the-same-time
        .filter(function (item) {
          return !item.children || !item.children.length;
        }).map(function (item) {
          return item.targetValue;
        }).indexOf(targetValue) > -1) {
          _this.setState({
            activeItem: targetValue
          });
        }

        _this.props.onChange(targetValue, _this.uuid, ev); // TODO: Separate active and expand

      }
    })), React.createElement(IconLink_1.IconLinkGroup, {
      className: CSSPrefix_1.lsgPre + "sidenavigation-bottomlinks",
      direction: IconLink_1.IconLinkGroup.Directions.VERTICAL
    }, this.props.bottomLinks));
    var TopLogo = React.createElement("a", {
      href: topLogoHref,
      className: CSSPrefix_1.lsgPre + "sidenavigation-head-coba-link"
    }, React.createElement(Logo_1.Logo, {
      size: Logo_1.Logo.Sizes.SMALL
    }), topLogoLabel);
    return ["xs", "sm", "md"].includes(this.state.viewport) ? // render mobile view (sidebar inside drawer)
    React.createElement("div", __assign({}, containerProps, {
      className: CSSPrefix_1.lsgPre + "sidenavigation " + CSSPrefix_1.lsgPre + "sidenavigation-mobile"
    }), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "sidenavigation-header",
      ref: function ref(_ref) {
        return _this.containerElm = _ref;
      }
    }, TopLogo, React.createElement(IconLink_1.IconLink, {
      iconName: Icon_1.Icon.Names.interaction___menu,
      iconOnly: true,
      onClick: this.toggleSideNavigation
    }, utils_1.Localization.texts.lsg.component.SideNavigation.openMenu)), React.createElement(Drawer_1.Drawer, {
      open: this.state.drawerOpen,
      layout: Drawer_1.Drawer.Layout.SIDEMENU_RIGHT,
      onCloseClick: this.toggleSideNavigation,
      htmlAttrs: {
        role: undefined
        /* unset role=dialog because this is a menu */

      }
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "sidenavigation-mobile-container"
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "sidenavigation-head"
    }, TopLogo, React.createElement(IconLink_1.IconLink, {
      iconName: Icon_1.Icon.Names.interaction___close,
      look: IconLink_1.IconLink.Looks.NO_TEXT_NO_HOVER,
      onClick: this.toggleSideNavigation
    }, utils_1.Localization.texts.lsg.component.SideNavigation.closeMenu)), sideNavigationContent))) : // render desktop view (always open sidebar)
    React.createElement("div", __assign({}, containerProps, {
      ref: function ref(_ref2) {
        return _this.containerElm = _ref2;
      },
      className: CSSPrefix_1.lsgPre + "sidenavigation " + CSSPrefix_1.lsgPre + "sidenavigation-desktop"
    }), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "sidenavigation-desktop-container",
      ref: function ref(_ref3) {
        return _this.containerElm = _ref3;
      }
    }, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "sidenavigation-head"
    }, TopLogo), sideNavigationContent));
  };

  SideNavigation.defaultProps = {
    topLogoLabel: "Web Design Guidelines",
    topLogoHref: "#",
    onSearchInputChange: function onSearchInputChange() {
      /* empty */
    },
    onChange: function onChange() {
      /* empty */
    }
  };
  return SideNavigation;
}(React.Component);

exports.SideNavigation = SideNavigation;